<h2 mat-dialog-title>{{'printerTableEditPrinterDialog.headingPrefix' | translate}} {{data.name}}
    {{'printerTableEditPrinterDialog.headingSuffix' | translate}}</h2>
<mat-dialog-content>
    <mat-form-field appearance="fill">
        <mat-label>{{'printerTableEditPrinterDialog.name' | translate}}</mat-label>
        <input matInput value="{{data.name}}" disabled>
    </mat-form-field>
    <mat-form-field appearance="fill">
        <mat-label>{{'printerTableEditPrinterDialog.description' | translate}}</mat-label>
        <input matInput [(ngModel)]="data.description">
    </mat-form-field>
    <mat-form-field appearance="fill">
        <mat-label>{{'printerTableEditPrinterDialog.location' | translate}}</mat-label>
        <input matInput [(ngModel)]="data.location">
    </mat-form-field>
    <mat-form-field appearance="fill">
        <mat-label>{{'printerTableEditPrinterDialog.connection' | translate}}</mat-label>
        <input matInput [(ngModel)]="data.deviceURI">
    </mat-form-field>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-button (click)="onNoClick()">{{'printerTableEditPrinterDialog.abort' | translate}}</button>
    <button mat-raised-button color="primary" [mat-dialog-close]="data"
        cdkFocusInitial>{{'printerTableEditPrinterDialog.save' | translate}}</button>
</mat-dialog-actions>